import { cellTypes } from "@visiblethread/react-components/dist/components/Table/TableCell";
import TextCell from "@visiblethread/react-components/dist/components/Table/cells/TextCell";
import ButtonCell from "@visiblethread/react-components/dist/components/Table/cells/ButtonCell";
import { ReactComponent as Trash } from "icons/trash.svg";
import AddChildrenCell from "@visiblethread/react-components/dist/components/Table/cells/AddChildrenCell";

const ValidatorType = Object.freeze({
  IS_EMPTY: 'isEmpty',
  IS_LENGTH_EXCEEDED: 'isLengthExceeded',
  IS_DUPLICATE: 'isDuplicate'
});

export const tableMapper = (dispatch, editMode, addNewTerm, deleteTerm, validations) => {
  const getHeader = () => [
    {
      text: "Ignore Terms",
      cellType: cellTypes.text,
      flexGrow: 1,
      minWidth: 500,
      autoResizable: true,
    },
    { cellType: cellTypes.text, text: "", minWidth: 50, defaultWidth: 150 },
  ];

  const getEmptyRowContent = () => [
    <div className="empty_row">
      <TextCell
        text="The ignore list is empty"
        viewOnly={!editMode}
        ariaLabel="Empty list description"
      />
    </div>,
  ];

  const getTermContent = (ignoreListItem, index, error) => [
    <TextCell
      text={ignoreListItem.term}
      editOnSelect={
        ignoreListItem.newlyCreated ||
        ignoreListItem.term.trim() === "" ||
        index === 0
      }
      ariaLabel="Term"
      error={error}
    />,
    <ButtonCell
      key="button"
      content={<Trash />}
      onClick={() => {
        dispatch(deleteTerm(index));
      }}
      title="Delete Ignore Term"
    />,
  ];

  const getAddNewTermContent = (index) => {
    return [
      <AddChildrenCell
        addChildrenText="Add Ignore Term"
        onClick={() => {
          dispatch(addNewTerm(index));
        }}
      />,
    ];
  };

  const getTermErrorMsg = (termToCheck, originalIndex, ignoreListItems) => {
    let errorMsg = "";

    // Skip validation for empty lists with an empty first term
    if (ignoreListItems.length === 1 && ignoreListItems[0].term === "") {
      return errorMsg;
    }

    // Only run-enabled validators
    for (const validatorName of validations.enabledValidators) {
      const validator = validations.validators[validatorName];

      if (validatorName === ValidatorType.IS_EMPTY && validator(termToCheck.term)) {
        errorMsg = validations.errorMessages[ValidatorType.IS_EMPTY];
        break;
      }
      else if (validatorName === ValidatorType.IS_LENGTH_EXCEEDED && validator(termToCheck.term, validations.maxLength)) {
        errorMsg = validations.errorMessages[ValidatorType.IS_LENGTH_EXCEEDED](validations.maxLength);
        break
      }
      else if (validatorName === ValidatorType.IS_DUPLICATE && validator(termToCheck.term, ignoreListItems, originalIndex)) {
        errorMsg = typeof validations.errorMessages[ValidatorType.IS_DUPLICATE] === 'function'
          ? validations.errorMessages[ValidatorType.IS_DUPLICATE](termToCheck.term)
          : validations.errorMessages[ValidatorType.IS_DUPLICATE];
        break;
      }
    }

    return errorMsg;
  };

  const getRows = (list) => {
    let ignoreList = [...list];

    if (!ignoreList) ignoreList = [];
    if (!editMode && ignoreList.length === 0) {
      return [
        {
          content: getEmptyRowContent(),
          parentIndex: 0,
          id: 0,
        },
      ];
    }

    const result = [];
    if (ignoreList.length === 0) {
      ignoreList.push({ term: "", newlyCreated: true });
    }

    ignoreList.forEach((ignoreListItem, index) => {
      const errorMsg = getTermErrorMsg(ignoreListItem, index, ignoreList);
      result.push({
        id: index,
        parentIndex: index,
        content: getTermContent(ignoreListItem, index, errorMsg),
        newlyCreated: ignoreListItem.newlyCreated,
      });
    });

    if (editMode) {
      result.push({
        content: getAddNewTermContent(result.length - 1),
        childrenOf: result.length - 1,
        id: result.length,
      });
    }

    return result;
  };

  const getState = (tableRows) => {
    const result = [];
    tableRows.forEach((row) => {
      if (row.parentIndex !== undefined) {
        result.push({ term: row.content[0].props.text, newlyCreated: false });
      }
    });
    return result;
  };

  return { getHeader, getRows, getState, ValidatorType };
};

export { ValidatorType };
